export const SET_STORE_USER = 'SET_STORE_USER' // 更新用户状态